import React, { useState } from "react";
import { TextField } from "@material-ui/core";
import axios from "axios";
import TwoFa from "../../../elements/twoFa/TwoFa";
import DialogModal from "../../../elements/dialogModal/DialogModal";
import { check2FA } from "../../../../utils/check2FA";
import getUserInfo from "../../../../utils/getUserInfo";
import userAuthenticationConfig from "../../../../utils/userAuthenticationConfig";
import { parseAxiosError } from "../../../../utils/response";
import { HTTP_STATUSES, STANDARD_ERRORS_WAY } from "../../../../utils/consts";

import DefaultButton from "../../../styles/materialButtonStyle";
import { StyledBlockAction, StyledInputBlock } from "../../../styles/styledTabsForm";

const ExchangeUserPairsEditForm = ({ t, userPair, notification, setNotification }) => {

  const [open, setOpen] = useState(false);
  const [error, setError] = useState({});

  const [submitData, setSubmitData] = useState({
    percent: null,
    constant: null
  });

  const inputProps = {
    step: "any"
  };

  const handleSave = async (event) => {
    event.preventDefault();

    let check2Fa = await check2FA(getUserInfo()["userId"], event.target.twofa.value);

    if (check2Fa.error) {
      setNotification({ ...notification, visible: true, type: "error", message: check2Fa.error });
      return;
    }

    axios.put("/api/user-exchange-pairs/" + userPair.id, submitData, userAuthenticationConfig()).then(response => {
      if (response.status === HTTP_STATUSES.HTTP_OK) {
        setOpen(false);
        setNotification({ ...notification, visible: true, type: "success", message: t("userPairs.details.changeForm.success") });
      }
    }).catch(error => {
      setOpen(false);
      parseAxiosError(eval(STANDARD_ERRORS_WAY), notification, setNotification);
    });
  };

  return (
    <>
      <DialogModal
        open={open}
        setOpen={setOpen}
        title={t("userPairs.details.changeForm.twoFa")}
        content={<TwoFa
          handleSubmit={handleSave}
          error={error}
        />}
      />
      <StyledInputBlock
        as="form"
        onSubmit={event => {
          event.preventDefault();

          setSubmitData({
            ...setSubmitData,
            percent: event.target.percent.value,
            constant: event.target.constant.value,
          });
          setOpen(true);
        }}
      >
        <TextField
          className="grid-form__input"
          variant="filled"
          label={t("userPairs.details.changeForm.percent")}
          id="percent"
          type="number"
          inputProps={inputProps}
          name="percent"
          defaultValue={userPair.percent * 100}
        />
        <TextField
          className="grid-form__input"
          variant="filled"
          label={t("userPairs.details.changeForm.constant")}
          id="constant"
          type="number"
          inputProps={inputProps}
          name="constant"
          defaultValue={userPair.constant}
        />
        <StyledBlockAction>
          <DefaultButton
            color="success"
            type="submit"
          >
            {t("userPairs.details.changeForm.save")}
          </DefaultButton>
        </StyledBlockAction>
      </StyledInputBlock>
    </>
  );
};

export default ExchangeUserPairsEditForm;